export default "__VITE_ASSET__sSahbhQw__"